import * as angular from 'angular';

function extractClientDomain(apiAddress) {
    let match = apiAddress.match(
        new RegExp('https?://(.+\\.(imieszkaniec\\.pl|properto\\.io))')
    );
    if (!match) {
        throw new Error(`Can't extract client domain from URL: ${apiAddress}`);
    }
    return match[1];
}

export class IMieszkaniecFactory {
    private $http;

    constructor($http) {
        this.$http = $http;
    }

    fetchCategories(clientId) {
        return this.$http.get(`/api/v1/improxy/issue_categories/${clientId}/`);
    }

    fetchCities(apiAddress, params) {
        params.client_domain = extractClientDomain(apiAddress);
        return this.$http.get('/api/v1/imcache/locations/cities/', {
            params: params,
        });
    }

    fetchStreets(apiAddress, params) {
        params.client_domain = extractClientDomain(apiAddress);
        return this.$http.get('/api/v1/imcache/locations/streets/', {
            params: params,
        });
    }

    fetchSettlements(apiAddress, params) {
        params.client_domain = extractClientDomain(apiAddress);
        return this.$http.get('/api/v1/imcache/locations/settlements/', {
            params: params,
        });
    }

    fetchRealEstates(apiAddress, params) {
        params.client_domain = extractClientDomain(apiAddress);
        return this.$http.get('/api/v1/imcache/locations/real_estates/', {
            params: params,
        });
    }

    fetchBuildings(apiAddress, params) {
        params.client_domain = extractClientDomain(apiAddress);
        return this.$http.get('/api/v1/imcache/locations/buildings/', {
            params: params,
        });
    }

    fetchBuildingParts(apiAddress, params) {
        params.client_domain = extractClientDomain(apiAddress);
        return this.$http.get('/api/v1/imcache/locations/building_parts/', {
            params: params,
        });
    }

    fetchProperties(apiAddress, params) {
        params.client_domain = extractClientDomain(apiAddress);
        return this.$http.get('/api/v1/imcache/locations/properties/', {
            params: params,
        });
    }
}

angular.module('app').service('IMieszkaniecFactory', IMieszkaniecFactory);



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/services/imieszkaniec.factory.ts